import { memo } from 'react';
import { formatNumber } from '@bonanza-social/toolkit/utils';
import { Box, Text } from '@bonanza-social/moonlight';
import { GoalCardProps } from './GoalCard.types';

function GoalCard({ threshold, disabled, ...rest }: GoalCardProps) {
  return (
    <Box alignItems="center" {...rest}>
      <Text
        variant="body-s"
        crossedOut={disabled}
        color={disabled ? 'darkSurfaceDisabled' : 'darkSurfacePrimary'}
      >
        {formatNumber(threshold, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
        })}
      </Text>
      <Text
        variant="caption-semi"
        locKey="groupWins"
        locNS="communityJackpot"
        color={disabled ? 'darkSurfaceDisabled' : 'darkSurfacePrimary'}
      />
    </Box>
  );
}

export default memo(GoalCard);
